import { createBrowserRouter } from 'react-router-dom';

import Homepage from '../pages/homepage/homepage';
import AboutPage from '../pages/about-page/about-page';
import ContactPage from '../pages/contact-page/contact-page';
import ProjectsPage from '../pages/project-page/project-page';
import ServicePage from '../pages/service-page/service-page';

export const router = createBrowserRouter([
  {
    path: '',
    element: <Homepage />,
  },
  {
    path: 'about-me',
    element: <AboutPage />,
  },
  {
    path: 'contact',
    element: <ContactPage />,
  },
  {
    path: 'my-projects',
    element: <ProjectsPage />,
  },
  {
    path: 'my-services',
    element: <ServicePage />,
  },
]);
